module.exports = "<ion-list can-swipe=\"false\">\n    <ion-item ng-repeat=\"processor in $ctrl.processors track by processor.id\"\n              on-tap=\"$ctrl.selectProcessor(processor)\"\n              class=\"item-icon-right\">\n\n        {{processor.name}}\n\n        <i class=\"icon ion-ios-checkmark\" ng-if=\"processor.name == $ctrl.selectedProcessor\"></i>\n        <i class=\"icon ion-ios-circle-outline\" ng-if=\"processor.name != $ctrl.selectedProcessor\"></i>\n    </ion-item>\n</ion-list>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/components/booking-processor-selection/booking-processor-selection.html
// module id = 924
// module chunks = 0